import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=283b81e0&scoped=true"
import script from "./PhoneField.vue?vue&type=script&lang=ts"
export * from "./PhoneField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b81e0",
  null
  
)

export default component.exports